export class TemplateDetailQueryParameters {
  assignTeamLead?: boolean;
  communicatorConversationId?: string;
  contactPreferenceId?: string;
  employeeId?: string;
  employeeRoleEnabled?: boolean;
  employeeRoleId?: string;
  headerId?: string;
  letterNumber?: string;
  page?: number;
  pageSize?: number;
  sequence?: string;
  syncExistingTasksAsEmployeeId?: string;
  constructor(obj?: TemplateDetailQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
